import type { Common } from '@libs/domain';
import type { EligibleBillingProvider } from '@libs/enums';
import { MstListSearch, MstListSearchRaw } from '@libs/templates/mst';

class LeaseCompanyMstListSearch
  extends MstListSearch
  implements Pick<Common['schema'], 'eligibleBillingProviderCondition' | 'phoneNo'>
{
  private constructor(
    mstListSearch: MstListSearch,
    readonly phoneNo: string,
    readonly eligibleBillingProviderCondition: Set<EligibleBillingProvider>,
  ) {
    super(
      mstListSearch.codeRange,
      mstListSearch.name,
      mstListSearch.mstSpareName01Condition,
      mstListSearch.mstSpareName02Condition,
      mstListSearch.validityStartDateCondition,
      mstListSearch.validityEndDateCondition,
      mstListSearch.mstNoteCondition,
    );
  }

  static init() {
    return new LeaseCompanyMstListSearch(MstListSearch.baseInit(), '', new Set());
  }
}

class LeaseCompanyMstListSearchRaw
  extends MstListSearchRaw
  implements Pick<Common['record'], 'eligibleBillingProviderCondition' | 'phoneNo'>
{
  private constructor(
    mstListSearchRaw: MstListSearchRaw,
    readonly phoneNo: string,
    readonly eligibleBillingProviderCondition: string[],
  ) {
    super(
      mstListSearchRaw.codeRange,
      mstListSearchRaw.isCodeRangeExcluded,
      mstListSearchRaw.name,
      mstListSearchRaw.mstSpareName01,
      mstListSearchRaw.isMstSpareName01BlankOnly,
      mstListSearchRaw.mstSpareName02,
      mstListSearchRaw.isMstSpareName02BlankOnly,
      mstListSearchRaw.validityStartDateFrom,
      mstListSearchRaw.validityStartDateTo,
      mstListSearchRaw.validityEndDateFrom,
      mstListSearchRaw.validityEndDateTo,
      mstListSearchRaw.mstNote,
      mstListSearchRaw.isMstNoteBlankOnly,
    );
  }

  static fromModel(model: LeaseCompanyMstListSearch) {
    return new LeaseCompanyMstListSearchRaw(MstListSearchRaw.baseFromModel(model), model.phoneNo, [
      ...model.eligibleBillingProviderCondition,
    ]);
  }
}

export { LeaseCompanyMstListSearch, LeaseCompanyMstListSearchRaw };
